import { combineReducers } from 'redux';

export const content = (state = {}, action) => {
  switch (action.type) {
    case 'SET_HELP': {
      const nextState = { ...state };
      nextState[action.help.id] = action.help;
      return nextState;
    }
    default:
      return state;
  }
};

export const file = (state = {}, action) => {
  switch (action.type) {
    case 'SET_HELP_FILE':
      return action.file;
    default:
      return state;
  }
};

export const contentOpen = (state = null, action) => {
  switch (action.type) {
    case 'SET_HELP_OPEN':
      return action.item;
    case 'SET_HELP_RESET':
    case 'SET_MODAL_HELP_CLOSED':
      return null;
    default:
      return state;
  }
};

export default combineReducers({
  content,
  file,
  contentOpen,
});

export const getHelpContent = (state) => Object.values(state.content);
export const getHelpOpen = (state) => state.contentOpen;
export const getHelpFile = (state) => state.file;
